import type { ReactNode } from 'react'

export const GuidedTourInteractionType = 'interaction-profile-guided-tour'
export const AgreedPlacePhotoInteractionType = 'interaction-agreed-place-photo'
export const ValidateMobileNumberInteractionType = 'interaction-validate-mobile-number'
export const NewServicePointInteractionType = 'interaction-new-servicepoint'

export type InteractionType =
  | typeof GuidedTourInteractionType
  | typeof AgreedPlacePhotoInteractionType
  | typeof ValidateMobileNumberInteractionType
  | typeof NewServicePointInteractionType

export type Interaction = {
  component: ReactNode
  shouldExecute: () => Promise<boolean>
  type: InteractionType
}

export type InteractionConfig = {
  interactions: Interaction[]
}
